import { render, staticRenderFns } from "./emailReg.vue?vue&type=template&id=7f96e5ec&scoped=true&"
import script from "./emailReg.vue?vue&type=script&lang=js&"
export * from "./emailReg.vue?vue&type=script&lang=js&"
import style0 from "./emailReg.vue?vue&type=style&index=0&id=7f96e5ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f96e5ec",
  null
  
)

export default component.exports